import axios from "axios";
import React from "react";
import { useEffect } from "react";

export const commonItems = [
  {
    label: "item0",
    link: "../home",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 11.9127C3 9.99127 3 9.03056 3.40674 8.19893C3.81348 7.36729 4.57181 6.77748 6.08847 5.59785L7.08848 4.82007C9.44787 2.98499 10.6276 2.06745 12 2.06745C13.3724 2.06745 14.5521 2.98499 16.9115 4.82008L17.9115 5.59785C19.4282 6.77748 20.1865 7.36729 20.5933 8.19893C21 9.03056 21 9.99127 21 11.9127V14C21 17.7712 21 19.6569 19.8284 20.8284C18.6569 22 16.7712 22 13 22H11C7.22876 22 5.34315 22 4.17157 20.8284C3 19.6569 3 17.7712 3 14V11.9127Z"
          stroke="1552B2"
          strokeWidth="1.5"
          stroke-miterlimit="10"
        />
        <path
          d="M9 17C9 16.0681 9 15.6022 9.15224 15.2346C9.35523 14.7446 9.74458 14.3552 10.2346 14.1522C10.6022 14 11.0681 14 12 14V14C12.9319 14 13.3978 14 13.7654 14.1522C14.2554 14.3552 14.6448 14.7446 14.8478 15.2346C15 15.6022 15 16.0681 15 17V22H9V17Z"
          stroke="1552B2"
          strokeWidth="1.5"
          stroke-miterlimit="10"
        />
      </svg>
    ),
  },
  {
    label: "item2",
    link: "../home/smartservicedashboard",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.125 9.375C13.125 7.30393 11.4461 5.625 9.375 5.625C7.30393 5.625 5.625 7.30393 5.625 9.375C5.625 11.4461 7.30393 13.125 9.375 13.125C11.4461 13.125 13.125 11.4461 13.125 9.375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 5.625H18.75C17.7145 5.625 16.875 6.46447 16.875 7.5V11.25C16.875 12.2855 17.7145 13.125 18.75 13.125H22.5C23.5355 13.125 24.375 12.2855 24.375 11.25V7.5C24.375 6.46447 23.5355 5.625 22.5 5.625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 16.875H7.5C6.46447 16.875 5.625 17.7145 5.625 18.75V22.5C5.625 23.5355 6.46447 24.375 7.5 24.375H11.25C12.2855 24.375 13.125 23.5355 13.125 22.5V18.75C13.125 17.7145 12.2855 16.875 11.25 16.875Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.375 20.625C24.375 18.5539 22.6961 16.875 20.625 16.875C18.5539 16.875 16.875 18.5539 16.875 20.625C16.875 22.6961 18.5539 24.375 20.625 24.375C22.6961 24.375 24.375 22.6961 24.375 20.625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item4",
    link: "../home/meeting",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 5.9375H8.75C5.98858 5.9375 3.75 8.17608 3.75 10.9375V22.5C3.75 25.2614 5.98858 27.5 8.75 27.5H21.25C24.0114 27.5 26.25 25.2614 26.25 22.5V10.9375C26.25 8.17608 24.0114 5.9375 21.25 5.9375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4.0625V7.8125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.25 4.0625V7.8125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 12.1875H26.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item6",
    link: "../home/task",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 4.98755H11.25C9.17893 4.98755 7.5 6.66648 7.5 8.73755V21.2375C7.5 23.3086 9.17893 24.9875 11.25 24.9875H18.75C20.8211 24.9875 22.5 23.3086 22.5 21.2375V8.73755C22.5 6.66648 20.8211 4.98755 18.75 4.98755Z"
          stroke=""
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M18.125 13.7375H11.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.625 17.4875H11.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.125 9.98755H11.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item1",
    link: "../home/smartattendance",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 15H15V7.5"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    label: "item3",
    link: "../home/request",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.75877 0C17.06 0 17.1846 0 17.3763 0.163265C17.568 0.326531 17.568 0.432653 17.568 12.6939L18.1432 13.1837C18.5074 13.4939 18.7183 13.7388 18.7183 13.8612C18.7183 13.9592 18.6224 14.1143 18.4978 14.2041C18.3444 14.3184 18.239 14.3429 18.1144 14.2857C18.0281 14.2367 17.9227 14.2204 17.8748 14.2449C17.8364 14.2694 16.7245 13.3714 13.0148 10.2041H12.4876C12.0754 10.2122 11.8933 10.2531 11.6441 10.4082C11.4619 10.5306 11.2894 10.7429 11.2319 10.9143C11.1744 11.0857 11.1552 11.3388 11.1839 11.4694C11.2223 11.6082 11.8645 12.3918 14.0213 14.7755V15.9184C14.0213 16.5469 14.0692 17.2571 14.1268 17.4939C14.1939 17.7224 14.3856 18.1143 14.5581 18.3429C14.7402 18.5796 15.0278 18.8653 15.1908 18.9714C15.3633 19.0857 15.6605 19.2245 15.8426 19.2898C16.0247 19.3551 16.389 19.4367 16.6574 19.4694C16.9162 19.502 17.2325 19.5755 17.3475 19.6408C17.5009 19.7224 17.568 19.8367 17.568 20C17.568 20.1633 17.4945 20.2857 17.3475 20.3673C17.2325 20.4327 16.9833 20.4898 16.8012 20.4898C16.619 20.4898 16.2452 20.4408 15.9864 20.3837C15.718 20.3184 15.277 20.1633 14.9895 20.0327C14.7115 19.902 14.2705 19.6 14.0117 19.3633C13.7529 19.1347 13.4366 18.7429 13.3024 18.5061C13.1778 18.2775 13.0244 17.8776 12.9669 17.6327C12.9094 17.3878 12.871 16.7265 12.871 15.1429L11.6249 13.7714C10.9347 13.0204 10.3117 12.2857 10.2254 12.1388C10.1391 12 10.0433 11.6571 10.0145 11.3878C9.97615 10.9959 10.0145 10.8163 10.1966 10.4571C10.3308 10.2122 10.5992 9.87755 10.8293 9.70612C11.0881 9.5102 11.4332 9.33878 11.7399 9.26531C12.0179 9.2 12.3342 9.14286 12.4397 9.14286C12.5451 9.14286 12.871 9.2 13.1586 9.27347C13.6283 9.38775 13.82 9.51837 14.9799 10.498C15.6892 11.102 16.3123 11.5673 16.3506 11.5347C16.389 11.4939 16.4177 9.1102 16.4177 0.979592H1.1765V7.33061C1.1765 12.3265 1.19567 13.7061 1.29153 13.8122C1.40656 13.9347 1.67496 13.9592 3.73588 13.9755C5.81597 14 6.07478 14.0163 6.22815 14.1469C6.38152 14.2776 6.41028 14.5143 6.49655 18.3265L6.83205 18.4245C7.06211 18.4898 8.03985 18.5224 9.87071 18.5224C12.5739 18.5306 12.5835 18.5306 12.7368 18.7184C12.8231 18.8163 12.8614 18.9878 12.8423 19.102C12.8135 19.2245 12.6793 19.3469 12.5164 19.4122C12.3151 19.4939 11.577 19.5102 9.37226 19.4939C6.78412 19.4694 6.45821 19.4531 6.16105 19.3143C5.97893 19.2327 4.62735 18.1469 3.16074 16.9061C1.3107 15.3469 0.419233 14.5306 0.02622 13.8776L0.00704862 7.08571C-0.0121227 0.612245 -0.00253705 0.293878 0.170005 0.146939C0.332962 0.00816326 0.735561 0 8.75877 0ZM8.79712 3.02041C11.4236 3.02041 11.4332 3.02041 11.577 3.20816C11.6536 3.30612 11.7207 3.45306 11.7207 3.53469C11.7207 3.60816 11.6345 3.74694 11.529 3.83673C11.3469 3.99184 11.2127 4 8.76836 4C6.47738 4 6.18981 3.98367 6.03644 3.85306C5.94058 3.77959 5.8639 3.64082 5.8639 3.55102C5.85431 3.46122 5.92141 3.29796 6.01727 3.2C6.17064 3.02041 6.18981 3.02041 8.79712 3.02041ZM3.94676 4.97959H8.79712C11.9604 4.97959 13.6379 5.00408 13.6379 5.06122C13.6379 5.1102 13.6762 5.12653 13.7337 5.10204C13.7817 5.07755 13.8775 5.1102 13.9255 5.16735C13.983 5.21633 14.0117 5.39592 14.0021 5.55102C13.983 5.7551 13.9063 5.86122 13.7337 5.93469C13.5516 6.01633 12.4301 6.03265 8.68209 6.01633C4.55066 6 3.85091 5.98367 3.72629 5.87755C3.65919 5.81224 3.56333 5.67347 3.53458 5.57551C3.49624 5.4449 3.54416 5.33061 3.71671 5.18367L3.94676 4.97959ZM3.76463 7.02041H8.72043C13.2832 7.02041 13.6954 7.03673 13.8488 7.16735C13.9446 7.24082 14.0213 7.39592 14.0213 7.5102C14.0117 7.62449 13.935 7.77959 13.8488 7.86122C13.6954 7.99184 13.3599 8.00816 8.86421 8C6.21857 8 3.94676 7.96735 3.83173 7.92653C3.70712 7.89388 3.58251 7.7551 3.54416 7.62449C3.48665 7.46122 3.51541 7.33061 3.61126 7.20816L3.76463 7.02041ZM18.7662 7.26531C18.8717 7.26531 19.025 7.31429 19.1017 7.36327C19.1784 7.42041 19.7248 7.9102 20.2999 8.44898C20.8847 8.98775 21.4981 9.57551 21.6515 9.7551C21.8145 9.92653 22.0349 10.2449 22.15 10.449C22.265 10.6449 22.4184 11.0286 22.5046 11.3061C22.5813 11.5755 22.6484 12.0082 22.6484 12.2857C22.6484 12.5551 22.4375 14.498 21.6899 20.449L22.1212 21.4694H22.7634C23.1277 21.4694 23.5111 21.4939 23.6262 21.5347C23.7508 21.5755 23.885 21.6735 23.9233 21.7551C23.9712 21.8449 24 22.3184 24 22.8163C23.9904 23.6408 23.9712 23.7225 23.7699 23.8531C23.6549 23.9347 23.4824 24 23.3865 24C23.3002 24 23.1373 23.8939 23.0318 23.7714C22.8785 23.6 22.8305 23.4286 22.8401 23.0367C22.8401 22.5551 22.8305 22.5224 22.6005 22.4898C22.4663 22.4653 20.6354 22.449 14.6923 22.449V23.0204C14.6923 23.5102 14.6635 23.6163 14.4527 23.7959C14.3281 23.902 14.1459 24 14.0501 24C13.9542 24 13.8008 23.9347 13.705 23.8531C13.5708 23.7388 13.5324 23.5347 13.5133 22.7429C13.4941 21.7959 13.5037 21.7714 13.7337 21.6163C13.9638 21.4694 14.1459 21.4612 17.3955 21.4612C19.2838 21.4612 20.8271 21.4367 20.8271 21.4041C20.8271 21.3714 20.7505 21.1592 20.6738 20.9388C20.5204 20.5388 20.53 20.3918 21.0189 16.3673C21.479 12.5714 21.5173 12.1551 21.4119 11.7143C21.3448 11.4367 21.1626 11.0204 21.0189 10.7755C20.8559 10.498 20.2903 9.90204 19.5427 9.22449C18.8717 8.61224 18.2773 8.03265 18.2103 7.92653C18.1144 7.77143 18.124 7.73061 18.239 7.67347C18.3157 7.63265 18.354 7.56735 18.3061 7.51837C18.2678 7.46122 18.3157 7.38775 18.402 7.34694C18.4978 7.29796 18.6608 7.26531 18.7662 7.26531Z"
          stroke=""
        />
      </svg>
    ),
  },

  {
    label: "item5",
    link: "../home/project",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.3625 6.25H7.6375C5.49049 6.25 3.75 7.99049 3.75 10.1375V19.8625C3.75 22.0095 5.49049 23.75 7.6375 23.75H22.3625C24.5095 23.75 26.25 22.0095 26.25 19.8625V10.1375C26.25 7.99049 24.5095 6.25 22.3625 6.25Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 12.5H26.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },


  {
    label: "item7",
    link: "../home/smartdocument",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.5 13.0125V21.25C22.5 22.2446 22.1049 23.1984 21.4017 23.9017C20.6984 24.6049 19.7446 25 18.75 25H11.25C10.2554 25 9.30161 24.6049 8.59835 23.9017C7.89509 23.1984 7.5 22.2446 7.5 21.25V8.75C7.5 7.75544 7.89509 6.80161 8.59835 6.09835C9.30161 5.39509 10.2554 5 11.25 5H14.4875C14.8154 5.00138 15.1297 5.13157 15.3625 5.3625L22.1375 12.1375C22.3684 12.3703 22.4986 12.6846 22.5 13.0125Z"
          stroke=""
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M15 5.6V11.25C15 11.5815 15.1317 11.8995 15.3661 12.1339C15.6005 12.3683 15.9185 12.5 16.25 12.5H21.9C21.9489 12.4993 21.9966 12.4843 22.0371 12.4568C22.0775 12.4293 22.109 12.3905 22.1277 12.3452C22.1463 12.3 22.1512 12.2502 22.1419 12.2022C22.1325 12.1542 22.1093 12.1099 22.075 12.075L15.425 5.425C15.3901 5.39074 15.3458 5.36749 15.2978 5.35813C15.2498 5.34877 15.2 5.35371 15.1548 5.37235C15.1095 5.39098 15.0708 5.42248 15.0432 5.46295C15.0157 5.50342 15.0007 5.55107 15 5.6Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.875 21.25V16.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 21.25V17.5"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.125 21.25V18.75"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item8",
    link: "../home/mom",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 5.9375H8.75C5.98858 5.9375 3.75 8.17608 3.75 10.9375V22.5C3.75 25.2614 5.98858 27.5 8.75 27.5H21.25C24.0114 27.5 26.25 25.2614 26.25 22.5V10.9375C26.25 8.17608 24.0114 5.9375 21.25 5.9375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4.0625V7.8125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.25 4.0625V7.8125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 12.1875H26.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    label: "item9",
    link: "../home/PayrollDashboard",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeWidth="1"
          d="M22.8258 0.00324688L23.0841 0.132819C23.225 0.210562 23.4364 0.371232 23.5538 0.495621C23.6665 0.625193 23.8121 0.858423 24 1.29897V22.7043L23.8826 22.9893C23.8121 23.1448 23.6665 23.3781 23.5538 23.5076C23.4364 23.632 23.225 23.7927 22.8258 24H1.17417L0.915851 23.8704C0.774951 23.7927 0.563601 23.632 0.446184 23.5076C0.333464 23.3781 0.187867 23.1448 0 22.7043V1.24714L0.131507 0.972446C0.201957 0.827325 0.342857 0.609644 0.446184 0.495621C0.549511 0.381597 0.718591 0.24166 0.821918 0.184648C0.925245 0.127636 1.08963 0.0602586 1.18826 0.0343442C1.28689 0.00842977 5.82387 -0.00711889 22.8258 0.00324688ZM1.06145 1.27305L0.939335 1.43372L0.915851 3.81267H23.0841L23.0607 1.43372C22.8399 1.18494 22.7037 1.09165 22.6145 1.06574C22.5112 1.03464 18.519 1.01391 11.9765 1.01909C6.08219 1.01909 1.43249 1.04501 1.34325 1.07092C1.25401 1.09165 1.1272 1.18494 1.06145 1.27305ZM0.939335 22.5695C1.15538 22.8183 1.29628 22.9116 1.38552 22.9375C1.48885 22.9686 5.4998 22.9893 12.0329 22.9893C20.811 22.9893 22.544 22.979 22.6708 22.9168C22.7554 22.8805 22.8775 22.782 22.9432 22.7043L23.0607 22.5643L23.0795 4.84924H0.915851L0.939335 22.5695ZM2.45166 1.95201C2.48454 1.95201 2.57378 1.98311 2.65362 2.02457C2.72877 2.07122 2.8274 2.17488 2.87436 2.26298C2.92603 2.37182 2.94481 2.4703 2.92133 2.57396C2.90254 2.65688 2.8227 2.78646 2.74755 2.85383C2.65362 2.94194 2.5456 2.98341 2.44227 2.98341C2.32016 2.98341 2.24031 2.94194 2.13699 2.82792C2.03836 2.72426 1.99609 2.6206 1.99139 2.50658C1.99139 2.41329 2.03366 2.27335 2.09002 2.19042C2.14168 2.1075 2.23562 2.02457 2.29198 1.99866C2.34834 1.97274 2.41879 1.95201 2.45166 1.95201ZM4.32094 1.97793C4.39609 1.98829 4.5182 2.07122 4.58865 2.15414C4.6591 2.24225 4.72016 2.37182 4.72016 2.4392C4.72016 2.51176 4.68728 2.64133 4.64971 2.72426C4.61213 2.81237 4.53699 2.90566 4.48532 2.93158C4.43366 2.96267 4.31624 2.98341 4.22701 2.98341C4.10489 2.98341 4.02505 2.94194 3.92172 2.82792C3.82309 2.72426 3.78082 2.6206 3.77613 2.50658C3.77613 2.41329 3.8184 2.27335 3.87476 2.19042C3.92642 2.1075 4.02035 2.02457 4.07671 1.99866C4.13307 1.97274 4.2411 1.96238 4.32094 1.97793ZM6.17613 1.98311C6.24188 1.99866 6.3499 2.0764 6.42035 2.15933C6.51429 2.26817 6.55186 2.36664 6.55186 2.49103C6.55186 2.6206 6.51429 2.71908 6.41566 2.82792C6.32172 2.93676 6.23249 2.98341 6.13386 2.98341C6.05401 2.98341 5.94129 2.96267 5.88023 2.93158C5.82387 2.90048 5.73464 2.802 5.68767 2.7139C5.62818 2.59987 5.60783 2.49103 5.62661 2.38737C5.6407 2.30445 5.69237 2.19561 5.73933 2.14378C5.7863 2.09713 5.87554 2.03494 5.94129 2.00902C6.00704 1.97793 6.11037 1.96756 6.17613 1.98311ZM17.8943 6.84984C18.1245 6.86539 18.4767 6.9224 18.6693 6.97941C18.8618 7.0416 19.1812 7.17636 19.3738 7.29038C19.5663 7.39922 19.8622 7.6169 20.0313 7.76721C20.2004 7.91751 20.4399 8.1922 20.562 8.37879C20.6888 8.56019 20.8626 8.87116 20.9519 9.06293C21.0411 9.25469 21.1585 9.59158 21.2149 9.81445C21.29 10.1202 21.3182 10.3535 21.3135 10.8096C21.3135 11.2138 21.29 11.5248 21.229 11.7684C21.182 11.9705 21.0834 12.2867 21.0082 12.4681C20.9331 12.6547 20.7781 12.9449 20.6654 13.1159C20.5573 13.287 20.3413 13.5565 20.191 13.7172C20.036 13.8778 19.7965 14.0903 19.6556 14.194C19.5147 14.2925 19.2611 14.4376 19.092 14.5101C18.9229 14.5827 18.6505 14.6812 18.4814 14.7226C18.3123 14.7641 17.9648 14.8004 17.7065 14.8004C17.3824 14.8004 17.1194 14.7693 16.8611 14.6967C16.6544 14.6397 16.3491 14.5205 16.18 14.4324C16.011 14.3495 15.7479 14.1784 15.593 14.054C15.438 13.9348 15.1937 13.6912 15.0528 13.5202C14.9119 13.344 14.7241 13.0797 14.6395 12.9294C14.5597 12.7739 14.4329 12.4992 14.3671 12.3126C14.2967 12.1312 14.2121 11.8254 14.1793 11.6388C14.1417 11.4574 14.1135 11.0843 14.1135 10.8096C14.1135 10.5401 14.1464 10.1669 14.184 9.9803C14.2215 9.7989 14.3108 9.49311 14.3765 9.30652C14.4423 9.12512 14.5879 8.81933 14.7006 8.63275C14.8086 8.45135 15.0575 8.13519 15.2501 7.93306C15.4427 7.73611 15.7386 7.48215 15.9029 7.37849C16.0673 7.26965 16.3632 7.12453 16.5558 7.05197C16.7483 6.98459 17.0348 6.90167 17.1898 6.87575C17.3448 6.84984 17.6595 6.83947 17.8943 6.84984ZM16.3444 8.29068C16.2129 8.3736 15.9734 8.59647 15.8043 8.78824C15.6211 8.99037 15.438 9.25988 15.3487 9.46201C15.2642 9.64859 15.1609 9.93884 15.1233 10.1099C15.0857 10.2809 15.0528 10.5971 15.0528 10.8096C15.0528 11.0272 15.0857 11.3538 15.128 11.5352C15.1656 11.7217 15.2689 12.0275 15.3581 12.2089C15.4474 12.3955 15.6493 12.6961 15.8137 12.8775C15.9781 13.0589 16.2458 13.2922 16.4149 13.3958C16.584 13.4995 16.8564 13.6239 17.0254 13.6705C17.1945 13.7172 17.4998 13.7586 17.7065 13.7638C17.9131 13.7638 18.209 13.7275 18.364 13.6861C18.519 13.6394 18.7491 13.5513 18.8806 13.4839C19.0074 13.4114 19.1483 13.3336 19.1859 13.3025C19.2423 13.2611 19.0685 13.0434 18.2607 12.1467L17.2603 11.0428C17.2603 8.61202 17.2415 7.90714 17.2227 7.91233C17.2039 7.91233 17.0536 7.96416 16.8845 8.02635C16.7155 8.08855 16.4712 8.20775 16.3444 8.29068ZM18.1996 10.6282L19.9139 12.5251C20.144 12.0586 20.2474 11.7839 20.2943 11.6129C20.3507 11.4108 20.3789 11.1361 20.3789 10.8096C20.3742 10.5401 20.3507 10.2135 20.3131 10.084C20.2802 9.95957 20.191 9.70042 20.1065 9.51384C20.0219 9.31689 19.8341 9.03183 19.6509 8.81415C19.4442 8.57574 19.2329 8.38915 19.0168 8.26476C18.8384 8.16111 18.58 8.03672 18.4438 7.99525L18.1902 7.91233L18.1996 10.6282ZM9.3135 8.5861C10.1072 8.5861 10.6755 8.60165 10.7319 8.63275C10.7836 8.66385 10.8587 8.75714 10.8963 8.84006C10.9573 8.97482 10.9667 9.52939 10.9667 16.718L11.3706 16.7336C11.7699 16.744 11.7793 16.7491 11.9202 16.9254C12.0423 17.086 12.0564 17.1379 12.0329 17.3141C12.0188 17.4488 11.9624 17.568 11.7652 17.7546H2.65362L2.5362 17.6406C2.46106 17.568 2.4047 17.4488 2.38591 17.3141C2.36712 17.1379 2.38121 17.0808 2.49863 16.9357C2.62074 16.7751 2.65832 16.7543 3.21722 16.718V14.505C3.22192 12.38 3.22192 12.2815 3.31115 12.1208C3.37691 12.0068 3.46145 11.9342 3.58356 11.898C3.68219 11.8721 4.27397 11.8461 4.89863 11.8461C5.80509 11.8461 6.0728 11.8617 6.19961 11.9239C6.29354 11.9705 6.39687 12.069 6.43444 12.1571C6.4955 12.2919 6.50489 12.665 6.50489 16.718H7.67906V12.8827C7.67906 9.47238 7.68845 9.03183 7.75421 8.87116C7.79648 8.77787 7.86693 8.67421 7.9092 8.64311C7.96086 8.60683 8.44932 8.5861 9.3135 8.5861ZM8.61839 16.718H10.0274V9.6175H8.61839V16.718ZM4.15656 16.718H5.56556L5.54207 12.9086L4.16125 12.8827L4.15656 16.718ZM17.6924 16.718C20.4211 16.718 20.9002 16.7284 21.0411 16.7958C21.1397 16.8424 21.2384 16.9409 21.2806 17.0394C21.3276 17.143 21.3464 17.2622 21.3276 17.3504C21.3135 17.4281 21.2431 17.5525 21.0411 17.7598L14.3953 17.7546L14.2544 17.5991C14.1605 17.4955 14.1135 17.3918 14.1135 17.2882C14.1135 17.2001 14.1417 17.0705 14.1699 17.0031C14.2027 16.9305 14.292 16.8373 14.3718 16.7958C14.4892 16.7336 15.0153 16.718 17.6924 16.718ZM2.83209 19.6723C2.92603 19.6723 3.05284 19.7138 3.1045 19.7656C3.16086 19.8122 3.23131 19.9055 3.25949 19.9677C3.28767 20.0351 3.31115 20.1439 3.31115 20.2165C3.31115 20.2891 3.2501 20.4186 3.17495 20.5119C3.06223 20.6519 3.00117 20.683 2.84149 20.683C2.6771 20.683 2.62544 20.6519 2.50333 20.5016C2.37652 20.3461 2.36243 20.2942 2.38591 20.1128C2.4047 19.9781 2.45636 19.8641 2.5362 19.7863C2.61605 19.7138 2.71937 19.6723 2.83209 19.6723ZM4.82818 19.6723H21.0646L21.182 19.8019C21.2477 19.8744 21.3135 19.9936 21.3276 20.0714C21.3464 20.1595 21.3276 20.2787 21.2806 20.3823C21.2384 20.486 21.1397 20.5845 21.0411 20.6311C20.8955 20.6985 19.8904 20.7089 12.9393 20.7089C5.98826 20.7089 4.98317 20.6985 4.83757 20.6311C4.72798 20.5793 4.64971 20.4929 4.60274 20.372C4.56517 20.2735 4.54168 20.1388 4.55577 20.0714C4.56986 20.0092 4.63562 19.89 4.70137 19.8122L4.82818 19.6723Z"
          stroke=""
        />
      </svg>
    ),
  },
  // {
  //   label: "item10",
  //   link: "",
  //   icon: (
  //     <span
  //       className="material-symbols-outlined span">
  //       list_alt
  //     </span>
  //   )
  // },

  {
    label: "item23",
    link: "../home/holiday",
    icon: <span className="material-symbols-outlined">videocam</span>,
  },

  {
    label: "item24",
    link: "../home/announcement",
    icon: (
      <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill=""
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8199 18.39C12.2599 18.45 12.7098 18.48 13.1698 18.48L17.3598 20.97C18.0698 21.4 18.9598 20.82 18.8598 19.99L18.4698 16.83C20.6098 15.33 21.9998 12.94 21.9998 10.24C21.9998 5.68999 18.0498 2 13.1698 2C8.28985 2 4.33984 5.68999 4.33984 10.24C4.33984 10.5 4.34985 10.75 4.37985 11M11.8199 18.39C12.5599 17.52 12.9998 16.42 12.9998 15.23C12.9998 12.39 10.5398 10.09 7.49985 10.09C6.33985 10.09 5.26985 10.42 4.37985 11M11.8199 18.39C10.8299 19.59 9.26 20.3598 7.5 20.3598L4.89 21.9098C4.45 22.1798 3.89 21.8098 3.95 21.2998L4.2 19.3298C2.86 18.3998 2 16.9098 2 15.2298C2 13.4698 2.93985 11.92 4.37985 11"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    )
  },



  {
    label: "item13",
    link: "../home/userList",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4375 12.2625C15.5086 12.2625 17.1875 10.5835 17.1875 8.51245C17.1875 6.44138 15.5086 4.76245 13.4375 4.76245C11.3664 4.76245 9.6875 6.44138 9.6875 8.51245C9.6875 10.5835 11.3664 12.2625 13.4375 12.2625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.0625 25.2375C4.0625 22.7511 5.05022 20.3666 6.80837 18.6084C8.56653 16.8503 10.9511 15.8625 13.4375 15.8625C15.9239 15.8625 18.3085 16.8503 20.0666 18.6084C21.8248 20.3666 22.8125 22.7511 22.8125 25.2375"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.1499 15.625C23.3036 16.3622 24.2523 17.379 24.9079 18.5809C25.5634 19.7828 25.9047 21.1309 25.8999 22.5"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5625 5.38745C20.3913 5.38745 21.1862 5.71669 21.7722 6.30274C22.3583 6.88879 22.6875 7.68365 22.6875 8.51245C22.6875 9.34125 22.3583 10.1361 21.7722 10.7222C21.1862 11.3082 20.3913 11.6375 19.5625 11.6375"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item11",
    link: "../home/sharedfolder",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 23.125H7.5C6.83696 23.125 6.20107 22.8616 5.73223 22.3928C5.26339 21.9239 5 21.288 5 20.625V9.375C5 8.71196 5.26339 8.07607 5.73223 7.60723C6.20107 7.13839 6.83696 6.875 7.5 6.875H12.7125C13.0424 6.87474 13.3691 6.93977 13.6737 7.06635C13.9784 7.19292 14.2549 7.37854 14.4875 7.6125L16.7625 9.8875C16.9951 10.1215 17.2716 10.3071 17.5763 10.4337C17.8809 10.5602 18.2076 10.6253 18.5375 10.625H22.5C23.163 10.625 23.7989 10.8884 24.2678 11.3572C24.7366 11.8261 25 12.462 25 13.125V16.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6375 20.4H22.925C22.9312 20.2876 22.9312 20.1749 22.925 20.0625C22.9471 19.7807 22.9106 19.4973 22.8179 19.2303C22.7252 18.9632 22.5782 18.7182 22.3863 18.5107C22.1944 18.3031 21.9616 18.1375 21.7026 18.0243C21.4436 17.911 21.1639 17.8525 20.8812 17.8525C20.5986 17.8525 20.3189 17.911 20.0599 18.0243C19.8009 18.1375 19.5681 18.3031 19.3762 18.5107C19.1843 18.7182 19.0373 18.9632 18.9446 19.2303C18.8519 19.4973 18.8154 19.7807 18.8375 20.0625C18.8252 20.1747 18.8252 20.2878 18.8375 20.4C18.4761 20.4 18.1296 20.5435 17.8741 20.7991C17.6185 21.0546 17.475 21.4011 17.475 21.7625C17.475 22.1239 17.6185 22.4704 17.8741 22.7259C18.1296 22.9814 18.4761 23.125 18.8375 23.125H23.6125C23.9739 23.125 24.3204 22.9814 24.5759 22.7259C24.8314 22.4704 24.975 22.1239 24.975 21.7625C24.975 21.4011 24.8314 21.0546 24.5759 20.7991C24.3204 20.5435 23.9739 20.4 23.6125 20.4H23.6375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item12",
    link: "../home/linksandvideos",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 10H20C21.3261 10 22.5979 10.5268 23.5355 11.4645C24.4732 12.4021 25 13.6739 25 15C25 16.3261 24.4732 17.5979 23.5355 18.5355C22.5979 19.4732 21.3261 20 20 20H18.75"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 20H10C8.67392 20 7.40215 19.4732 6.46447 18.5355C5.52678 17.5979 5 16.3261 5 15C5 13.6739 5.52678 12.4021 6.46447 11.4645C7.40215 10.5268 8.67392 10 10 10H11.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 15H18.75"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item15",
    link: "../home/assets",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4125 10.45H6.53745C4.79775 10.45 3.38745 11.8603 3.38745 13.6V21.4375C3.38745 23.1771 4.79775 24.5875 6.53745 24.5875H18.4125C20.1521 24.5875 21.5625 23.1771 21.5625 21.4375V13.6C21.5625 11.8603 20.1521 10.45 18.4125 10.45Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.38745 15.5H21.5625"
          stroke=""
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M8.43752 9.9999V8.5499C8.43588 8.13683 8.51582 7.7275 8.67276 7.34539C8.82969 6.96329 9.06054 6.61594 9.35205 6.32327C9.64355 6.0306 9.98999 5.79838 10.3715 5.63992C10.7529 5.48146 11.1619 5.3999 11.575 5.3999H23.475C23.8881 5.3999 24.2971 5.48146 24.6786 5.63992C25.0601 5.79838 25.4065 6.0306 25.698 6.32327C25.9895 6.61594 26.2204 6.96329 26.3773 7.34539C26.5342 7.7275 26.6142 8.13683 26.6125 8.5499V16.3999C26.6142 16.813 26.5342 17.2223 26.3773 17.6044C26.2204 17.9865 25.9895 18.3339 25.698 18.6265C25.4065 18.9192 25.0601 19.1514 24.6786 19.3099C24.2971 19.4683 23.8881 19.5499 23.475 19.5499H21.5625"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item14",
    link: "../home/group",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5373 12.425C14.4289 12.425 15.9623 10.8915 15.9623 8.99995C15.9623 7.10838 14.4289 5.57495 12.5373 5.57495C10.6457 5.57495 9.1123 7.10838 9.1123 8.99995C9.1123 10.8915 10.6457 12.425 12.5373 12.425Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8874 15.8625H6.1749C4.95297 15.8625 3.9624 16.8531 3.9624 18.075V22.225C3.9624 23.447 4.95297 24.4375 6.1749 24.4375H18.8874C20.1093 24.4375 21.0999 23.447 21.0999 22.225V18.075C21.0999 16.8531 20.1093 15.8625 18.8874 15.8625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 6C19.0456 6 19.8087 6.31607 20.3713 6.87868C20.9339 7.44129 21.25 8.20435 21.25 9C21.25 9.79565 20.9339 10.5587 20.3713 11.1213C19.8087 11.6839 19.0456 12 18.25 12"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 14.0625C23.046 14.0658 23.5687 14.2841 23.9548 14.6702C24.3409 15.0563 24.5592 15.579 24.5625 16.125V21.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },



  {
    label: "item16",
    link: "../home/ainote",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.375 6.875C19.375 4.45875 17.4162 2.5 15 2.5C12.5838 2.5 10.625 4.45875 10.625 6.875V13.125C10.625 15.5412 12.5838 17.5 15 17.5C17.4162 17.5 19.375 15.5412 19.375 13.125V6.875Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.125 13.125C23.125 15.2799 22.269 17.3465 20.7452 18.8702C19.2215 20.394 17.1549 21.25 15 21.25C12.8451 21.25 10.7785 20.394 9.25476 18.8702C7.73102 17.3465 6.875 15.2799 6.875 13.125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 21.25V27.5"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 6.25H16.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 10H16.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item17",
    link: "/home/aidocumentengine",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeWidth="1"
          stroke=""
          fill="none"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.35889 0.00669493L16.8716 0L17.8265 0.174068C18.3434 0.274492 19.0972 0.455255 19.4921 0.582459C19.887 0.709663 20.4829 0.943986 20.8203 1.10466C21.1577 1.25865 21.7393 1.58 22.1126 1.81433C22.5577 2.08882 23.1105 2.52399 23.6992 3.07297C24.3095 3.64874 24.7546 4.13077 25.0777 4.58603C25.3361 4.95425 25.7095 5.57018 25.9033 5.95849C26.1043 6.3468 26.3413 6.90248 26.4418 7.19705C26.5423 7.49163 26.6715 7.98706 26.7361 8.30172C26.8007 8.61638 26.8797 9.23231 26.9228 9.67418C26.9587 10.116 26.9946 10.8994 26.9946 12.3522L27.4038 12.399C27.6335 12.4258 27.9782 12.4994 28.1648 12.5664C28.3587 12.6333 28.6602 12.794 28.8469 12.9212C29.0264 13.0484 29.2776 13.2761 29.3997 13.4233C29.5217 13.5706 29.7012 13.8719 29.974 14.4945L29.9956 20.8547C30.0099 24.8248 29.9884 27.389 29.9453 27.6836C29.9022 27.9447 29.7802 28.3263 29.6581 28.5539C29.5361 28.7882 29.292 29.0962 29.0622 29.2903C28.8038 29.518 28.5238 29.6853 27.6766 29.9933H17.5178L17.3742 29.8058C17.288 29.7054 17.2234 29.5514 17.2234 29.4577C17.2234 29.364 17.288 29.2167 17.5034 28.9556L27.6766 28.8886L27.9997 28.7146C28.1792 28.6141 28.4089 28.4133 28.5238 28.2593C28.6315 28.112 28.7535 27.8241 28.7894 27.63C28.8397 27.4091 28.854 25.0457 28.8253 14.6284L28.6674 14.3606C28.5812 14.2133 28.4089 13.9991 28.2725 13.8786C28.1433 13.7648 27.9351 13.6242 27.8202 13.5773C27.6479 13.5104 26.3987 13.4836 16.3332 13.4233L15.9024 13.2359C15.5434 13.0752 15.1701 12.7672 13.6409 11.3546C12.5352 10.3303 11.6809 9.59384 11.164 9.33943H7.89735C4.8461 9.33943 4.61636 9.34613 4.37944 9.46664C4.24303 9.53359 4.03483 9.66748 3.92714 9.76791C3.81227 9.86164 3.65432 10.0625 3.56817 10.2098C3.42458 10.4575 3.41022 10.6115 3.33843 13.6711L3.15894 13.7983C3.05843 13.8719 2.90766 13.9322 2.82151 13.9255C2.72818 13.9255 2.57023 13.8518 2.26151 13.6041L2.23998 12.2383C2.22562 11.4349 2.24716 10.7119 2.29023 10.4776C2.34049 10.2566 2.45536 9.9152 2.54869 9.72104C2.6492 9.53359 2.8933 9.21892 3.08715 9.03816C3.28817 8.8507 3.63278 8.62307 3.86252 8.52265C4.08508 8.42892 4.48713 8.3218 5.24097 8.23477L5.26251 5.10154C5.27687 2.06873 5.28405 1.96162 5.43481 1.60678C5.52097 1.39255 5.75071 1.07119 5.97327 0.843562C6.24609 0.569069 6.49737 0.388306 6.85634 0.227628L7.35889 0.00669493ZM6.86352 1.51975C6.75582 1.62017 6.60506 1.80094 6.54044 1.90806C6.43993 2.08882 6.42557 2.48382 6.41121 5.17518L6.38967 8.23477C9.69938 8.24146 10.8553 8.26824 11.0922 8.29502C11.3291 8.3285 11.7168 8.43562 11.9537 8.53604C12.3199 8.69002 12.6501 8.95782 14.2152 10.4106C15.5291 11.6358 16.1393 12.1513 16.3691 12.2517C16.6849 12.3789 16.8142 12.3856 21.2869 12.3856L25.8818 12.3923C25.8028 10.1294 25.731 9.19214 25.6736 8.83731C25.609 8.48918 25.4941 7.98036 25.4079 7.69917C25.329 7.42468 25.2141 7.11671 25.1567 7.01629L25.0561 6.82883L21.7177 6.79536C20.9782 6.474 20.6408 6.24637 20.4398 6.05892C20.2459 5.87815 20.009 5.56349 19.9013 5.35595C19.7075 4.99442 19.7075 4.97434 19.6931 3.40103L19.6716 1.80763C19.1403 1.59339 18.6808 1.4595 18.3075 1.37246C17.9342 1.28543 17.3526 1.185 17.0152 1.14483C16.649 1.10466 14.646 1.07788 12.0255 1.07788C7.93325 1.07788 7.62453 1.08458 7.35889 1.19839C7.20095 1.26534 6.97839 1.41263 6.86352 1.51975ZM20.9854 4.95425C21.0716 5.11493 21.2439 5.32917 21.3659 5.4229C21.4952 5.51663 21.7177 5.63044 21.8685 5.6773C22.0408 5.72417 22.5936 5.75764 23.3187 5.75764C23.9577 5.75764 24.4818 5.74425 24.4818 5.72417C24.4818 5.71078 24.3741 5.53671 24.2377 5.34256C24.1085 5.1484 23.8069 4.76679 23.57 4.48561C23.3331 4.21111 22.931 3.80272 22.6726 3.58179C22.4141 3.36086 21.9475 3.01272 21.6387 2.80518C21.3228 2.59094 21.0213 2.40348 20.9567 2.3767C20.8562 2.33653 20.8418 2.45704 20.8346 3.49476C20.8203 4.57264 20.8346 4.67976 20.9854 4.95425ZM4.09944 14.9967C4.22867 14.9967 4.37944 15.0636 4.48713 15.164C4.65944 15.3314 4.66662 15.3582 4.66662 17.206H5.52815V16.8244C5.52815 16.5164 5.56404 16.4093 5.69327 16.2888C5.77942 16.2017 5.93737 16.1348 6.05224 16.1348C6.15993 16.1348 6.29634 16.1616 6.36096 16.1884C6.42557 16.2151 6.52608 16.3222 6.57634 16.4227C6.63377 16.5231 6.67685 16.744 6.67685 17.206H7.46659L7.48812 16.2687C7.50248 15.3314 7.50248 15.3247 7.70351 15.164C7.8112 15.0703 7.96914 14.9967 8.06248 14.9967C8.14863 14.9967 8.30658 15.0569 8.61529 15.2644V17.206H9.47682V16.8378C9.47682 16.5432 9.50554 16.4428 9.65631 16.3022C9.77118 16.195 9.90758 16.1415 10.0655 16.1415C10.2091 16.1415 10.3671 16.195 10.4676 16.2888C10.5968 16.4093 10.6255 16.5097 10.6255 17.206H11.4871V16.3022C11.4871 15.8067 11.5158 15.3515 11.5517 15.2845C11.5804 15.2176 11.7168 15.1239 11.846 15.077C12.0399 14.9967 12.1117 14.9967 12.2911 15.077C12.406 15.1239 12.5209 15.2109 12.5496 15.2644C12.5711 15.3247 12.6142 15.7867 12.6717 17.2194L12.9588 17.3131C13.1168 17.36 13.3322 17.5006 13.447 17.6278C13.5547 17.7483 13.6552 17.9424 13.7127 18.2772H14.7537C15.7444 18.2772 15.8019 18.2906 15.9383 18.4312C16.0173 18.5115 16.0819 18.6655 16.0819 18.7659C16.0819 18.8663 16.0532 19.0069 16.0101 19.0806C15.9742 19.1542 15.8306 19.2479 15.7085 19.2881C15.5793 19.3216 15.0768 19.3551 13.7127 19.3484V20.0848H14.1075C14.4522 20.0848 14.5311 20.1116 14.7178 20.2857C14.8901 20.453 14.926 20.5267 14.8973 20.7074C14.8757 20.8279 14.7896 20.9819 14.6963 21.0422C14.5886 21.1292 14.4163 21.1627 13.7127 21.156V21.9594H14.7034C15.5793 21.9594 15.7085 21.9728 15.888 22.0933C16.046 22.2004 16.0819 22.2807 16.0819 22.495C16.0819 22.7159 16.046 22.7962 15.888 22.9034C15.7085 23.0239 15.5793 23.0373 13.7127 23.0306V23.834H14.1291C14.4163 23.834 14.5886 23.8674 14.6963 23.9545C14.7896 24.0147 14.8757 24.1687 14.8973 24.2892C14.926 24.4633 14.8901 24.5436 14.725 24.7043C14.5383 24.8851 14.4665 24.9052 13.7127 24.9052V25.6416H14.5957C15.0768 25.6416 15.5793 25.6751 15.7085 25.7085C15.8306 25.7487 15.9742 25.8357 16.0101 25.9094C16.0532 25.983 16.0819 26.1303 16.0819 26.2307C16.0819 26.3312 16.0101 26.4852 15.9167 26.5655C15.766 26.7128 15.7085 26.7195 13.7127 26.7128L13.6768 26.9337C13.6552 27.0542 13.5547 27.2484 13.447 27.3689C13.3322 27.4961 13.1168 27.6367 12.6717 27.7773L12.6573 28.6008C12.6429 29.056 12.6214 29.4979 12.5999 29.5782C12.5783 29.6586 12.4922 29.7925 12.406 29.8661C12.3127 29.9397 12.1547 30 12.047 30C11.9322 30 11.7671 29.9264 11.6665 29.8259C11.4942 29.6653 11.4871 29.6318 11.4871 27.784H10.6255V28.1723C10.6255 28.4802 10.5896 28.5874 10.4604 28.7079C10.3671 28.8016 10.2163 28.8619 10.0871 28.8619C9.9722 28.8619 9.79272 28.8083 9.69938 28.7414C9.55579 28.6476 9.52708 28.5539 9.47682 27.784H8.61529V28.7414C8.61529 29.6385 8.60093 29.7054 8.45016 29.846C8.35683 29.9397 8.20607 30 8.07684 30C7.94043 30 7.79684 29.9397 7.68197 29.8259C7.50966 29.6586 7.50248 29.6117 7.46659 27.784H6.67685L6.64813 28.2058C6.62659 28.5539 6.59788 28.6476 6.45429 28.7414C6.36096 28.8083 6.18865 28.8619 6.0666 28.8619C5.94455 28.8552 5.77942 28.7882 5.68609 28.7079C5.55686 28.5874 5.52815 28.4869 5.52815 27.784H4.66662V28.7213C4.66662 29.6318 4.65944 29.6653 4.48713 29.8259C4.38662 29.9264 4.22867 30 4.1138 30C4.00611 30 3.8338 29.9464 3.73329 29.8728C3.56099 29.7456 3.55381 29.7054 3.48201 27.7773L3.19484 27.6836C3.03689 27.63 2.83587 27.5162 2.74253 27.4358C2.65638 27.3555 2.54151 27.1613 2.39074 26.7463L1.33537 26.7128C0.308715 26.686 0.272818 26.6793 0.143588 26.5119C0.0646147 26.4249 0 26.2977 0 26.2307C0 26.1638 0.0574353 26.0366 0.129229 25.9429C0.193844 25.8491 0.351791 25.742 0.466662 25.7085C0.588712 25.6751 1.07691 25.6416 2.441 25.6416V24.9052H2.04613C1.70152 24.9052 1.62255 24.8851 1.43588 24.7043C1.31383 24.5905 1.2205 24.4365 1.2205 24.3361C1.2205 24.2491 1.29947 24.0951 1.39998 24.0013C1.54357 23.8607 1.63691 23.834 2.441 23.834V23.0306H1.43588C0.466662 23.0306 0.423585 23.0306 0.215382 22.8632C0.0646147 22.7494 0 22.6423 0 22.495C0 22.3544 0.0646147 22.2473 0.215382 22.1268C0.423585 21.9661 0.466662 21.9594 2.441 21.9594V21.156H2.01023C1.64408 21.156 1.55075 21.1359 1.39998 20.9886C1.29947 20.9016 1.2205 20.7476 1.2205 20.6539C1.2205 20.5601 1.31383 20.3995 1.4287 20.2857C1.61537 20.1116 1.68716 20.0848 2.441 20.0848V19.3484L1.56511 19.3551C1.07691 19.3551 0.588712 19.3216 0.466662 19.2881C0.351791 19.2546 0.193844 19.1475 0.129229 19.0538C0.0574353 18.9601 0 18.8328 0 18.7659C0 18.6989 0.0646147 18.5717 0.143588 18.478C0.272818 18.3173 0.308715 18.3106 2.39074 18.2437L2.48408 17.9759C2.54151 17.8286 2.65638 17.6411 2.74253 17.5608C2.83587 17.4805 3.03689 17.3667 3.48201 17.2194L3.51791 16.2419C3.55381 15.3046 3.56099 15.2511 3.72611 15.1306C3.81945 15.0569 3.98457 14.9967 4.09944 14.9967ZM3.5897 26.7128H12.564V18.2772H3.5897V26.7128ZM7.17941 19.7701C7.7753 19.7902 7.90453 19.8103 8.20607 19.971C8.39273 20.0714 8.62965 20.2656 8.74452 20.4062C8.85221 20.5401 8.97426 20.761 9.02452 20.8882C9.08195 21.0489 9.11067 21.7184 9.11785 24.8382L8.90965 25.0391C8.79478 25.1529 8.64401 25.2399 8.58657 25.2399C8.52196 25.2399 8.39991 25.2064 8.31376 25.1663C8.22042 25.1194 8.11273 25.0391 8.06248 24.9788C8.00504 24.9118 7.97632 24.5704 7.96914 23.0306H6.17429V24.8382L5.96609 25.0391C5.85122 25.1529 5.70045 25.2399 5.64302 25.2399C5.5784 25.2399 5.44199 25.1997 5.3343 25.1529C5.21943 25.0993 5.11174 25.0123 5.08302 24.952C5.04712 24.8918 5.02559 24.008 5.02559 22.9837C5.02559 21.6983 5.0543 21.0422 5.11892 20.8681C5.162 20.7208 5.31994 20.4865 5.45635 20.3392C5.59276 20.1919 5.80096 20.0245 5.90865 19.971C6.01635 19.9107 6.19583 19.8438 6.30352 19.8103C6.41121 19.7835 6.80608 19.7634 7.17941 19.7701ZM6.26044 21.0823C6.21019 21.1426 6.17429 21.3635 6.17429 21.5778V21.9594H7.96914C7.96914 21.2765 7.94043 21.2029 7.75376 21.0221C7.55992 20.8413 7.4953 20.8279 7.09326 20.8279C6.84198 20.8279 6.57634 20.8614 6.49737 20.9016C6.41839 20.9418 6.3107 21.0221 6.26044 21.0823ZM10.6614 19.7902C10.7835 19.8036 10.9342 19.8906 11.006 19.971C11.1209 20.1116 11.1353 20.3124 11.1353 22.495C11.1281 24.3829 11.1065 24.9052 11.0348 25.0056C10.9773 25.0792 10.8409 25.1663 10.726 25.1997C10.604 25.2265 10.446 25.2198 10.3383 25.1796C10.2378 25.1462 10.1158 25.0391 10.0727 24.9453C10.0009 24.8181 9.97938 24.1821 9.97938 22.495C9.97938 20.8079 10.0009 20.1785 10.0727 20.0513C10.1158 19.9643 10.2235 19.8572 10.3025 19.8237C10.3814 19.7835 10.5466 19.7701 10.6614 19.7902Z"
        />
      </svg>
    ),
  },
  {
    label: "item18",
    link: "/home/Bot",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_4986_10798"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="30"
          height="30"
        >
          <rect width="30" height="30" fill="" />
        </mask>
          <path
            d="M2.76316 16.25C1.97862 16.25 1.32204 15.9708 0.793421 15.4125C0.264474 14.8545 0 14.1615 0 13.3333C0 12.5052 0.264474 11.8122 0.793421 11.2542C1.32204 10.6958 1.97862 10.4167 2.76316 10.4167V5.86563C2.76316 5.05451 3.03668 4.36024 3.58372 3.78281C4.13076 3.20538 4.78849 2.91667 5.55691 2.91667H12.2368C12.2368 2.08854 12.5013 1.39549 13.0303 0.837501C13.5589 0.279168 14.2155 0 15 0C15.7845 0 16.4411 0.279168 16.9697 0.837501C17.4987 1.39549 17.7632 2.08854 17.7632 2.91667H24.4431C25.2115 2.91667 25.8692 3.20538 26.4163 3.78281C26.9633 4.36024 27.2368 5.05451 27.2368 5.86563V10.4167C28.0214 10.4167 28.678 10.6958 29.2066 11.2542C29.7355 11.8122 30 12.5052 30 13.3333C30 14.1615 29.7355 14.8545 29.2066 15.4125C28.678 15.9708 28.0214 16.25 27.2368 16.25V25.801C27.2368 26.6122 26.9632 27.3064 26.4158 27.8839C25.8681 28.4613 25.2099 28.75 24.4411 28.75H5.5426C4.77385 28.75 4.11842 28.4613 3.57632 27.8839C3.03421 27.3064 2.76316 26.6122 2.76316 25.801V16.25ZM9.07451 13.5417C9.45707 13.5417 9.78372 13.4003 10.0544 13.1177C10.3252 12.8351 10.4605 12.4918 10.4605 12.088C10.4605 11.6842 10.3266 11.3394 10.0589 11.0536C9.79112 10.7679 9.46595 10.625 9.08339 10.625C8.70082 10.625 8.37418 10.7663 8.10345 11.049C7.83273 11.3316 7.69737 11.6748 7.69737 12.0786C7.69737 12.4825 7.83125 12.8273 8.09901 13.113C8.36678 13.3988 8.69194 13.5417 9.07451 13.5417ZM20.3245 13.5417C20.7071 13.5417 21.0337 13.4003 21.3044 13.1177C21.5752 12.8351 21.7105 12.4918 21.7105 12.088C21.7105 11.6842 21.5766 11.3394 21.3089 11.0536C21.0411 10.7679 20.716 10.625 20.3334 10.625C19.9508 10.625 19.6242 10.7663 19.3535 11.049C19.0827 11.3316 18.9474 11.6748 18.9474 12.0786C18.9474 12.4825 19.0813 12.8273 19.349 13.113C19.6168 13.3988 19.9419 13.5417 20.3245 13.5417ZM8.88158 21.0417H21.1184V19.375H8.88158V21.0417ZM5.55691 27.0833H24.4431C24.7974 27.0833 25.0885 26.9632 25.3164 26.7229C25.5441 26.4823 25.6579 26.175 25.6579 25.801V5.86563C25.6579 5.49167 25.5441 5.18437 25.3164 4.94375C25.0885 4.70347 24.7974 4.58333 24.4431 4.58333H5.55691C5.20263 4.58333 4.91151 4.70347 4.68355 4.94375C4.45592 5.18437 4.34211 5.49167 4.34211 5.86563V25.801C4.34211 26.175 4.45592 26.4823 4.68355 26.7229C4.91151 26.9632 5.20263 27.0833 5.55691 27.0833Z"
            fill=""
          />
      </svg>
    ),
  },
  {
    label: "item19",
    link: "/home/ocr",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6625 24.9999H9.45C8.2708 24.9966 7.14084 24.5267 6.30702 23.6929C5.4732 22.8591 5.0033 21.7291 5 20.5499V18.3374"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.9999 18.3374V20.5499C24.9966 21.7291 24.5267 22.8591 23.6929 23.6929C22.8591 24.5267 21.7291 24.9966 20.5499 24.9999H18.3374"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3374 5H20.5499C21.7291 5.0033 22.8591 5.4732 23.6929 6.30702C24.5267 7.14084 24.9966 8.2708 24.9999 9.45V11.6625"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 11.6625V9.45C5.0033 8.2708 5.4732 7.14084 6.30702 6.30702C7.14084 5.4732 8.2708 5.0033 9.45 5H11.6625"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 15H25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    label: "item25",
    link: "../home/aipdfgenerator",
    icon: <svg
    width="24"
    height="22"
    viewBox="0 0 25 23"
    fill=""
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2308 21.6249V19.75H20.3653C20.4695 19.75 20.5597 19.7179 20.6358 19.6538C20.7119 19.5897 20.75 19.5056 20.75 19.4014V10.6586C20.75 8.26918 19.895 6.25756 18.1851 4.62375C16.4751 2.98996 14.4134 2.17306 12 2.17306C9.58651 2.17306 7.52481 2.98996 5.81487 4.62375C4.10494 6.25756 3.24997 8.26918 3.24997 10.6586V18.0192H2.3125C1.71315 18.0192 1.19873 17.8104 0.76925 17.393C0.33975 16.9755 0.125 16.4671 0.125 15.8678V13.4399C0.125 13.0344 0.240386 12.663 0.471156 12.3257C0.701927 11.9884 1.00321 11.7171 1.375 11.512L1.43272 9.91584C1.53526 8.55528 1.88861 7.29488 2.49278 6.13463C3.09695 4.97436 3.87178 3.96433 4.81728 3.10456C5.7628 2.24479 6.85415 1.57493 8.09131 1.09497C9.3285 0.61499 10.6314 0.375 12 0.375C13.3686 0.375 14.6682 0.61499 15.899 1.09497C17.1298 1.57493 18.2211 2.24159 19.173 3.09497C20.125 3.94832 20.8998 4.95513 21.4975 6.11538C22.0953 7.27563 22.4518 8.53604 22.5672 9.89663L22.6249 11.4615C22.9887 11.633 23.288 11.8782 23.5228 12.1971C23.7575 12.516 23.8749 12.8718 23.8749 13.2644V16.0553C23.8749 16.4479 23.7575 16.8036 23.5228 17.1225C23.288 17.4415 22.9887 17.6866 22.6249 17.8581V19.4014C22.6249 20.0168 22.4042 20.5412 21.9627 20.9747C21.5212 21.4082 20.9887 21.6249 20.3653 21.6249H11.2308ZM8.49038 13.2115C8.18429 13.2115 7.92348 13.1077 7.70794 12.9002C7.4924 12.6927 7.38463 12.4359 7.38463 12.1298C7.38463 11.8237 7.4924 11.5649 7.70794 11.3533C7.92348 11.1418 8.18429 11.036 8.49038 11.036C8.79646 11.036 9.05727 11.1418 9.27281 11.3533C9.48835 11.5649 9.59613 11.8237 9.59613 12.1298C9.59613 12.4359 9.48835 12.6927 9.27281 12.9002C9.05727 13.1077 8.79646 13.2115 8.49038 13.2115ZM15.5096 13.2115C15.2035 13.2115 14.9427 13.1077 14.7271 12.9002C14.5116 12.6927 14.4038 12.4359 14.4038 12.1298C14.4038 11.8237 14.5116 11.5649 14.7271 11.3533C14.9427 11.1418 15.2035 11.036 15.5096 11.036C15.8156 11.036 16.0765 11.1418 16.292 11.3533C16.5075 11.5649 16.6153 11.8237 16.6153 12.1298C16.6153 12.4359 16.5075 12.6927 16.292 12.9002C16.0765 13.1077 15.8156 13.2115 15.5096 13.2115ZM4.96394 11.2499C4.83413 9.2099 5.46874 7.46431 6.86778 6.01319C8.26682 4.56208 9.99839 3.83653 12.0625 3.83653C13.7964 3.83653 15.3265 4.37299 16.6526 5.44591C17.9787 6.5188 18.7836 7.90781 19.0673 9.61294C17.2916 9.5921 15.651 9.12576 14.1454 8.21391C12.6398 7.30205 11.484 6.05206 10.6779 4.46394C10.3606 6.01842 9.6955 7.3926 8.68269 8.5865C7.66985 9.7804 6.43027 10.6682 4.96394 11.2499Z"
      fill=""
    />
  </svg>,
  },
  {
    label: "item21",
    link: "../home/itsupportmanager",
    icon: (
      <svg
        width="24"
        height="22"
        viewBox="0 0 25 23"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2308 21.6249V19.75H20.3653C20.4695 19.75 20.5597 19.7179 20.6358 19.6538C20.7119 19.5897 20.75 19.5056 20.75 19.4014V10.6586C20.75 8.26918 19.895 6.25756 18.1851 4.62375C16.4751 2.98996 14.4134 2.17306 12 2.17306C9.58651 2.17306 7.52481 2.98996 5.81487 4.62375C4.10494 6.25756 3.24997 8.26918 3.24997 10.6586V18.0192H2.3125C1.71315 18.0192 1.19873 17.8104 0.76925 17.393C0.33975 16.9755 0.125 16.4671 0.125 15.8678V13.4399C0.125 13.0344 0.240386 12.663 0.471156 12.3257C0.701927 11.9884 1.00321 11.7171 1.375 11.512L1.43272 9.91584C1.53526 8.55528 1.88861 7.29488 2.49278 6.13463C3.09695 4.97436 3.87178 3.96433 4.81728 3.10456C5.7628 2.24479 6.85415 1.57493 8.09131 1.09497C9.3285 0.61499 10.6314 0.375 12 0.375C13.3686 0.375 14.6682 0.61499 15.899 1.09497C17.1298 1.57493 18.2211 2.24159 19.173 3.09497C20.125 3.94832 20.8998 4.95513 21.4975 6.11538C22.0953 7.27563 22.4518 8.53604 22.5672 9.89663L22.6249 11.4615C22.9887 11.633 23.288 11.8782 23.5228 12.1971C23.7575 12.516 23.8749 12.8718 23.8749 13.2644V16.0553C23.8749 16.4479 23.7575 16.8036 23.5228 17.1225C23.288 17.4415 22.9887 17.6866 22.6249 17.8581V19.4014C22.6249 20.0168 22.4042 20.5412 21.9627 20.9747C21.5212 21.4082 20.9887 21.6249 20.3653 21.6249H11.2308ZM8.49038 13.2115C8.18429 13.2115 7.92348 13.1077 7.70794 12.9002C7.4924 12.6927 7.38463 12.4359 7.38463 12.1298C7.38463 11.8237 7.4924 11.5649 7.70794 11.3533C7.92348 11.1418 8.18429 11.036 8.49038 11.036C8.79646 11.036 9.05727 11.1418 9.27281 11.3533C9.48835 11.5649 9.59613 11.8237 9.59613 12.1298C9.59613 12.4359 9.48835 12.6927 9.27281 12.9002C9.05727 13.1077 8.79646 13.2115 8.49038 13.2115ZM15.5096 13.2115C15.2035 13.2115 14.9427 13.1077 14.7271 12.9002C14.5116 12.6927 14.4038 12.4359 14.4038 12.1298C14.4038 11.8237 14.5116 11.5649 14.7271 11.3533C14.9427 11.1418 15.2035 11.036 15.5096 11.036C15.8156 11.036 16.0765 11.1418 16.292 11.3533C16.5075 11.5649 16.6153 11.8237 16.6153 12.1298C16.6153 12.4359 16.5075 12.6927 16.292 12.9002C16.0765 13.1077 15.8156 13.2115 15.5096 13.2115ZM4.96394 11.2499C4.83413 9.2099 5.46874 7.46431 6.86778 6.01319C8.26682 4.56208 9.99839 3.83653 12.0625 3.83653C13.7964 3.83653 15.3265 4.37299 16.6526 5.44591C17.9787 6.5188 18.7836 7.90781 19.0673 9.61294C17.2916 9.5921 15.651 9.12576 14.1454 8.21391C12.6398 7.30205 11.484 6.05206 10.6779 4.46394C10.3606 6.01842 9.6955 7.3926 8.68269 8.5865C7.66985 9.7804 6.43027 10.6682 4.96394 11.2499Z"
          fill=""
        />
      </svg>
    ),
  },
  
  // {
  //   label: "item22",
  //   link: "../home/joinMeeting",
  //   icon: <span className="material-symbols-outlined">videocam</span>,
  // },
  // {
  //   label: "item20",
  //   link: "../home/chat",
  //   icon: (
  //     <svg
  //       width="30"
  //       height="30"
  //       viewBox="0 0 30 30"
  //       fill=""
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M11.8199 18.39C12.2599 18.45 12.7098 18.48 13.1698 18.48L17.3598 20.97C18.0698 21.4 18.9598 20.82 18.8598 19.99L18.4698 16.83C20.6098 15.33 21.9998 12.94 21.9998 10.24C21.9998 5.68999 18.0498 2 13.1698 2C8.28985 2 4.33984 5.68999 4.33984 10.24C4.33984 10.5 4.34985 10.75 4.37985 11M11.8199 18.39C12.5599 17.52 12.9998 16.42 12.9998 15.23C12.9998 12.39 10.5398 10.09 7.49985 10.09C6.33985 10.09 5.26985 10.42 4.37985 11M11.8199 18.39C10.8299 19.59 9.26 20.3598 7.5 20.3598L4.89 21.9098C4.45 22.1798 3.89 21.8098 3.95 21.2998L4.2 19.3298C2.86 18.3998 2 16.9098 2 15.2298C2 13.4698 2.93985 11.92 4.37985 11"
  //         stroke="#1552B2"
  //         strokeWidth="1.5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  // },




];

// Inbox Item

const baseUrl =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_BASE_URL_DEV
    : process.env.REACT_APP_BASE_URL_PROD;

async function fetchDocuments() {
  try {
    const token = localStorage.getItem("Mandoobee-token");
    const response = await axios.get(`${baseUrl}/home/managerInbox`, {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      return response.data?.result;
    } else {
      throw new Error("Failed to fetch documents");
    }
  } catch (error) {
    console.error("Error fetching documents:", error);
  }
}

// Function to initialize inboxItems once data is fetched
export async function initializeInboxItems() {
  const countInbox = await fetchDocuments();

  const inboxItems = [
    {
      label: "item5",
      link: "../home/smartservicedashboard",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.125 9.375C13.125 7.30393 11.4461 5.625 9.375 5.625C7.30393 5.625 5.625 7.30393 5.625 9.375C5.625 11.4461 7.30393 13.125 9.375 13.125C11.4461 13.125 13.125 11.4461 13.125 9.375Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5 5.625H18.75C17.7145 5.625 16.875 6.46447 16.875 7.5V11.25C16.875 12.2855 17.7145 13.125 18.75 13.125H22.5C23.5355 13.125 24.375 12.2855 24.375 11.25V7.5C24.375 6.46447 23.5355 5.625 22.5 5.625Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 16.875H7.5C6.46447 16.875 5.625 17.7145 5.625 18.75V22.5C5.625 23.5355 6.46447 24.375 7.5 24.375H11.25C12.2855 24.375 13.125 23.5355 13.125 22.5V18.75C13.125 17.7145 12.2855 16.875 11.25 16.875Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.375 20.625C24.375 18.5539 22.6961 16.875 20.625 16.875C18.5539 16.875 16.875 18.5539 16.875 20.625C16.875 22.6961 18.5539 24.375 20.625 24.375C22.6961 24.375 24.375 22.6961 24.375 20.625Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      label: "item3", // Use translation key
      link: "../home/meeting",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.25 5.9375H8.75C5.98858 5.9375 3.75 8.17608 3.75 10.9375V22.5C3.75 25.2614 5.98858 27.5 8.75 27.5H21.25C24.0114 27.5 26.25 25.2614 26.25 22.5V10.9375C26.25 8.17608 24.0114 5.9375 21.25 5.9375Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4.0625V7.8125"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.25 4.0625V7.8125"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 12.1875H26.25"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 17.4875V17.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 17.4875V17.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 17.4875V17.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 22.4875V22.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 22.4875V22.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 22.4875V22.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      count: countInbox?.meeting || 0,
    },
    {
      label: "item4", // Use translation key
      link: "../home/task",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.75 4.98755H11.25C9.17893 4.98755 7.5 6.66648 7.5 8.73755V21.2375C7.5 23.3086 9.17893 24.9875 11.25 24.9875H18.75C20.8211 24.9875 22.5 23.3086 22.5 21.2375V8.73755C22.5 6.66648 20.8211 4.98755 18.75 4.98755Z"
            stroke=""
            strokeWidth="1.5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M18.125 13.7375H11.875"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.625 17.4875H11.875"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.125 9.98755H11.875"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      count: countInbox?.tasks || 0,
    },
    {
      label: "item1", 
      link: "../home/smartdocument",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.5 13.0125V21.25C22.5 22.2446 22.1049 23.1984 21.4017 23.9017C20.6984 24.6049 19.7446 25 18.75 25H11.25C10.2554 25 9.30161 24.6049 8.59835 23.9017C7.89509 23.1984 7.5 22.2446 7.5 21.25V8.75C7.5 7.75544 7.89509 6.80161 8.59835 6.09835C9.30161 5.39509 10.2554 5 11.25 5H14.4875C14.8154 5.00138 15.1297 5.13157 15.3625 5.3625L22.1375 12.1375C22.3684 12.3703 22.4986 12.6846 22.5 13.0125Z"
            stroke=""
            strokeWidth="1.5"
            stroke-miterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M15 5.6V11.25C15 11.5815 15.1317 11.8995 15.3661 12.1339C15.6005 12.3683 15.9185 12.5 16.25 12.5H21.9C21.9489 12.4993 21.9966 12.4843 22.0371 12.4568C22.0775 12.4293 22.109 12.3905 22.1277 12.3452C22.1463 12.3 22.1512 12.2502 22.1419 12.2022C22.1325 12.1542 22.1093 12.1099 22.075 12.075L15.425 5.425C15.3901 5.39074 15.3458 5.36749 15.2978 5.35813C15.2498 5.34877 15.2 5.35371 15.1548 5.37235C15.1095 5.39098 15.0708 5.42248 15.0432 5.46295C15.0157 5.50342 15.0007 5.55107 15 5.6Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.875 21.25V16.25"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 21.25V17.5"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.125 21.25V18.75"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      count: countInbox?.smartDocument || 0,
    },
    {
      label: "item2", // Use translation key
      link: "../home/mom",
      icon: (
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.25 5.9375H8.75C5.98858 5.9375 3.75 8.17608 3.75 10.9375V22.5C3.75 25.2614 5.98858 27.5 8.75 27.5H21.25C24.0114 27.5 26.25 25.2614 26.25 22.5V10.9375C26.25 8.17608 24.0114 5.9375 21.25 5.9375Z"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4.0625V7.8125"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.25 4.0625V7.8125"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.75 12.1875H26.25"
            stroke=""
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 17.4875V17.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 17.4875V17.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 17.4875V17.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 22.4875V22.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 22.4875V22.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 22.4875V22.5"
            stroke=""
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      count: countInbox?.momDocuments || 0,
    },
  ];

  return inboxItems;
}

// CeoInboxItems
export async function initializeCeoInboxItems() {
  const countInbox = await fetchDocuments();

  const CeoInboxItems = [
    {
      label: "item1",
      link: "../home/mom",
      count: countInbox?.momDocuments || 0,
    },
    {
      label: "item2",
      link: "../home/document",
      count: countInbox?.smartDocument || 0,
    },
    {
      label: "item3",
      link: "../home/smartservice",
      count: countInbox?.smartServices || 0,
    },
  ];
  return CeoInboxItems;
}

// Most used Service
export const MostusedItems = [
  {
    label: "item1",
    link: "../home/smartservicedashboard",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.125 9.375C13.125 7.30393 11.4461 5.625 9.375 5.625C7.30393 5.625 5.625 7.30393 5.625 9.375C5.625 11.4461 7.30393 13.125 9.375 13.125C11.4461 13.125 13.125 11.4461 13.125 9.375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 5.625H18.75C17.7145 5.625 16.875 6.46447 16.875 7.5V11.25C16.875 12.2855 17.7145 13.125 18.75 13.125H22.5C23.5355 13.125 24.375 12.2855 24.375 11.25V7.5C24.375 6.46447 23.5355 5.625 22.5 5.625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 16.875H7.5C6.46447 16.875 5.625 17.7145 5.625 18.75V22.5C5.625 23.5355 6.46447 24.375 7.5 24.375H11.25C12.2855 24.375 13.125 23.5355 13.125 22.5V18.75C13.125 17.7145 12.2855 16.875 11.25 16.875Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.375 20.625C24.375 18.5539 22.6961 16.875 20.625 16.875C18.5539 16.875 16.875 18.5539 16.875 20.625C16.875 22.6961 18.5539 24.375 20.625 24.375C22.6961 24.375 24.375 22.6961 24.375 20.625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item2",
    link: "../home/meeting",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.25 5.9375H8.75C5.98858 5.9375 3.75 8.17608 3.75 10.9375V22.5C3.75 25.2614 5.98858 27.5 8.75 27.5H21.25C24.0114 27.5 26.25 25.2614 26.25 22.5V10.9375C26.25 8.17608 24.0114 5.9375 21.25 5.9375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 4.0625V7.8125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.25 4.0625V7.8125"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.75 12.1875H26.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 17.4875V17.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 22.4875V22.5"
          stroke=""
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item3",
    link: "../home/task",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 4.98755H11.25C9.17893 4.98755 7.5 6.66648 7.5 8.73755V21.2375C7.5 23.3086 9.17893 24.9875 11.25 24.9875H18.75C20.8211 24.9875 22.5 23.3086 22.5 21.2375V8.73755C22.5 6.66648 20.8211 4.98755 18.75 4.98755Z"
          stroke=""
          strokeWidth="1.5"
          stroke-miterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M18.125 13.7375H11.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.625 17.4875H11.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.125 9.98755H11.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

// Knowlegdehub
export const KnowledgehubItems = [
  {
    label: "item1",
    link: "../home/userList",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4375 12.2625C15.5086 12.2625 17.1875 10.5835 17.1875 8.51245C17.1875 6.44138 15.5086 4.76245 13.4375 4.76245C11.3664 4.76245 9.6875 6.44138 9.6875 8.51245C9.6875 10.5835 11.3664 12.2625 13.4375 12.2625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.0625 25.2375C4.0625 22.7511 5.05022 20.3666 6.80837 18.6084C8.56653 16.8503 10.9511 15.8625 13.4375 15.8625C15.9239 15.8625 18.3085 16.8503 20.0666 18.6084C21.8248 20.3666 22.8125 22.7511 22.8125 25.2375"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.1499 15.625C23.3036 16.3622 24.2523 17.379 24.9079 18.5809C25.5634 19.7828 25.9047 21.1309 25.8999 22.5"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5625 5.38745C20.3913 5.38745 21.1862 5.71669 21.7722 6.30274C22.3583 6.88879 22.6875 7.68365 22.6875 8.51245C22.6875 9.34125 22.3583 10.1361 21.7722 10.7222C21.1862 11.3082 20.3913 11.6375 19.5625 11.6375"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item2",
    link: "../home/sharedfolder",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.75 23.125H7.5C6.83696 23.125 6.20107 22.8616 5.73223 22.3928C5.26339 21.9239 5 21.288 5 20.625V9.375C5 8.71196 5.26339 8.07607 5.73223 7.60723C6.20107 7.13839 6.83696 6.875 7.5 6.875H12.7125C13.0424 6.87474 13.3691 6.93977 13.6737 7.06635C13.9784 7.19292 14.2549 7.37854 14.4875 7.6125L16.7625 9.8875C16.9951 10.1215 17.2716 10.3071 17.5763 10.4337C17.8809 10.5602 18.2076 10.6253 18.5375 10.625H22.5C23.163 10.625 23.7989 10.8884 24.2678 11.3572C24.7366 11.8261 25 12.462 25 13.125V16.875"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6375 20.4H22.925C22.9312 20.2876 22.9312 20.1749 22.925 20.0625C22.9471 19.7807 22.9106 19.4973 22.8179 19.2303C22.7252 18.9632 22.5782 18.7182 22.3863 18.5107C22.1944 18.3031 21.9616 18.1375 21.7026 18.0243C21.4436 17.911 21.1639 17.8525 20.8812 17.8525C20.5986 17.8525 20.3189 17.911 20.0599 18.0243C19.8009 18.1375 19.5681 18.3031 19.3762 18.5107C19.1843 18.7182 19.0373 18.9632 18.9446 19.2303C18.8519 19.4973 18.8154 19.7807 18.8375 20.0625C18.8252 20.1747 18.8252 20.2878 18.8375 20.4C18.4761 20.4 18.1296 20.5435 17.8741 20.7991C17.6185 21.0546 17.475 21.4011 17.475 21.7625C17.475 22.1239 17.6185 22.4704 17.8741 22.7259C18.1296 22.9814 18.4761 23.125 18.8375 23.125H23.6125C23.9739 23.125 24.3204 22.9814 24.5759 22.7259C24.8314 22.4704 24.975 22.1239 24.975 21.7625C24.975 21.4011 24.8314 21.0546 24.5759 20.7991C24.3204 20.5435 23.9739 20.4 23.6125 20.4H23.6375Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item3",
    link: "../home/linksandvideos",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.75 10H20C21.3261 10 22.5979 10.5268 23.5355 11.4645C24.4732 12.4021 25 13.6739 25 15C25 16.3261 24.4732 17.5979 23.5355 18.5355C22.5979 19.4732 21.3261 20 20 20H18.75"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 20H10C8.67392 20 7.40215 19.4732 6.46447 18.5355C5.52678 17.5979 5 16.3261 5 15C5 13.6739 5.52678 12.4021 6.46447 11.4645C7.40215 10.5268 8.67392 10 10 10H11.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.25 15H18.75"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  {
    label: "item5",
    link: "../home/assets",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4125 10.45H6.53745C4.79775 10.45 3.38745 11.8603 3.38745 13.6V21.4375C3.38745 23.1771 4.79775 24.5875 6.53745 24.5875H18.4125C20.1521 24.5875 21.5625 23.1771 21.5625 21.4375V13.6C21.5625 11.8603 20.1521 10.45 18.4125 10.45Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.38745 15.5H21.5625"
          stroke=""
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M8.43752 9.9999V8.5499C8.43588 8.13683 8.51582 7.7275 8.67276 7.34539C8.82969 6.96329 9.06054 6.61594 9.35205 6.32327C9.64355 6.0306 9.98999 5.79838 10.3715 5.63992C10.7529 5.48146 11.1619 5.3999 11.575 5.3999H23.475C23.8881 5.3999 24.2971 5.48146 24.6786 5.63992C25.0601 5.79838 25.4065 6.0306 25.698 6.32327C25.9895 6.61594 26.2204 6.96329 26.3773 7.34539C26.5342 7.7275 26.6142 8.13683 26.6125 8.5499V16.3999C26.6142 16.813 26.5342 17.2223 26.3773 17.6044C26.2204 17.9865 25.9895 18.3339 25.698 18.6265C25.4065 18.9192 25.0601 19.1514 24.6786 19.3099C24.2971 19.4683 23.8881 19.5499 23.475 19.5499H21.5625"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: "item6",
    link: "../home/group",
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5373 12.425C14.4289 12.425 15.9623 10.8915 15.9623 8.99995C15.9623 7.10838 14.4289 5.57495 12.5373 5.57495C10.6457 5.57495 9.1123 7.10838 9.1123 8.99995C9.1123 10.8915 10.6457 12.425 12.5373 12.425Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.8874 15.8625H6.1749C4.95297 15.8625 3.9624 16.8531 3.9624 18.075V22.225C3.9624 23.447 4.95297 24.4375 6.1749 24.4375H18.8874C20.1093 24.4375 21.0999 23.447 21.0999 22.225V18.075C21.0999 16.8531 20.1093 15.8625 18.8874 15.8625Z"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.25 6C19.0456 6 19.8087 6.31607 20.3713 6.87868C20.9339 7.44129 21.25 8.20435 21.25 9C21.25 9.79565 20.9339 10.5587 20.3713 11.1213C19.8087 11.6839 19.0456 12 18.25 12"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.5 14.0625C23.046 14.0658 23.5687 14.2841 23.9548 14.6702C24.3409 15.0563 24.5592 15.579 24.5625 16.125V21.25"
          stroke=""
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];


